import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { InventarioFilter, Inventario } from 'src/app/farmacia/estoque/inventario/inventario.model';
import { MyAutocomplete } from '../../framework/input-components/my-autocomplete';
import { ErrorHandlerService } from '../../framework/error-handler.service';
import { InventarioService } from 'src/app/farmacia/estoque/inventario/inventario.service';
import { Status } from '../../framework/default.model';
import { ListaResultset } from '../../list/lista-resultset.interface';


@Component({
  selector: 'app-autocomplete-inventario',
  templateUrl: './autocomplete-inventario.component.html',
  styleUrls: ['./autocomplete-inventario.component.css']
})
export class AutocompleteInventarioComponent implements OnInit {

  public autocomplete: MyAutocomplete<Inventario>;
  formDisabled = false;

  @Input() bloqueado = false;
  @Input() exibirLimpar = true;
  @Input() placeholder = 'Setor';

  @Input() idUnidade = null;

  public inventarioFilter: InventarioFilter = null;

  constructor(
    private httpClient: HttpClient
    , private errorHandlerService: ErrorHandlerService
    , private inventarioService: InventarioService
  ) {
    this.inventarioFilter = {
      status: Status.ATIVO
    };
  }

  ngOnInit(): void {
    this.carregarDados();
  }

  ngOnDestroy(): void {
    if ( this.autocomplete ) {
      this.autocomplete.destroy();
    }
  }

  getMyAutocomplete(): MyAutocomplete<Inventario> {
    return this.autocomplete;
  }

  public getInventarioFilter(): InventarioFilter {
    return this.inventarioFilter;
  }

  public setInventarioFilter(filter: InventarioFilter): void {
    this.inventarioFilter = filter;
  }

  private carregarDados(): void {
    const autoBuscarItemPorCampo = 'nome';
    const fnBuscarItem = (filter: any): Observable<ListaResultset<any>> => {
      if ( filter?.query?.length > 0 ) {
        this.inventarioFilter.nome = filter.query;
      }
      else {
        delete this.inventarioFilter.nome;
      }

      if ( this.idUnidade || this.idUnidade === 0 ) {
        this.inventarioFilter.idUnidade = this.idUnidade;
      }

      return this.inventarioService
                 .listar(this.inventarioFilter)
                 .pipe( debounceTime(300) );
    }

    this.autocomplete = new MyAutocomplete(
      this.httpClient,
      this.errorHandlerService,
      InventarioService.URL,
      fnBuscarItem,
      null,
      autoBuscarItemPorCampo,
      false
    );
  }

}
